'use client';
import { createTheme, type ThemeOptions } from '@mui/material/styles';
import siteConfig from '@/config/site';

/**
 * Thème dérivé de la marque Primeur Condorcet : vert feuillage + accent
 * carotte, sur des neutres teintés chaud (crème). Titres en serif (Fraunces)
 * pour le caractère artisanal du primeur, corps de texte en sans (Inter).
 * On règle la forme et les poids ici plutôt qu’en `sx` épars.
 */
const base: ThemeOptions = {
  palette: {
    mode: siteConfig.brand.mode,
    primary: { main: siteConfig.brand.primary },
    secondary: { main: siteConfig.brand.secondary },
    background: {
      default: '#fbf7ef', // crème chaude
      paper: '#fffdf8',
    },
    text: {
      primary: '#26331f', // vert profond teinté
      secondary: '#5c6354',
    },
    divider: '#e7e0d2',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: 'var(--font-inter), system-ui, -apple-system, sans-serif',
    h1: { fontFamily: 'var(--font-fraunces), Georgia, serif', fontWeight: 600, letterSpacing: '-0.02em' },
    h2: { fontFamily: 'var(--font-fraunces), Georgia, serif', fontWeight: 600, letterSpacing: '-0.01em' },
    h3: { fontFamily: 'var(--font-fraunces), Georgia, serif', fontWeight: 600 },
    h4: { fontFamily: 'var(--font-fraunces), Georgia, serif', fontWeight: 600 },
    h5: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 999 } },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 16 } },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0, color: 'inherit' },
    },
  },
};

export const theme = createTheme(base);
export default theme;
